import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class PageNavigationService {


    private navigationTabsDisabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


    constructor() { }

    public disableNavigationTabs(): void {
        this.navigationTabsDisabled$.next(true);
    }

    public enableNavigationTabs(): void {
        this.navigationTabsDisabled$.next(false);
    }

    public getNavigationTabDisabledStatus(): Observable<boolean> {
        return this.navigationTabsDisabled$;
    }
    
}